const ALL_URL = {
    login: "/account/login",
    logout: '/account/logout',
    sendVerifyCodeForRegister: "/account/regist1",
    sendForgotPasswordVerifyCode: "/account/forgetpw1",
    register: "/account/regist2",
    forgotPassword: "/account/forgetpw2",
    updatePassword: "/account/changepw",
    invitelist: "/account/invitelist",
    getUserInfo: "/account/user",
    updateUserInfo: "/account/updateuser",
    getProductList: "/product/list",
    createOrder: "/shop/order",
    getPayLink: "/shop/pay",
    getOrderStatus: "/shop/orderstate",
    orderlist: "/shop/orderlist",
    orderdetail: "/shop/orderdetail",
    cancelorder: "/shop/cancelorder",
    getLatestVersion: "/base/latestversion",
    getCouponList: "/market/couponlist",
    takeCoupon: "/market/takecoupon",
    getUserAuthList: "/auth/userauth",
    dropUserAuth: "/auth/dropauth",
    consumeSummary: "/point/consume-summary",
    applyInvoice:"/invoice/apply",
    getTransactions: "/point/transactions",
    getConsumeCurrentMonth: "/point/consume-current-month",
    exportTransactions: "/point/export-transactions",
    nextRefreshPeriod :'/point/next-refresh-period',
};

/**
 * Mock 配置：键为 ALL_URL 中的 key，值为 true 表示该接口使用 mock 数据。
 * 仅在 dev 环境下生效，生产构建会被 tree-shake 移除。
 */
export const MOCK_CONFIG = {
    // register: true,
    // getTransactions: true,
    // consumeSummary:true,
    // orderlist: true,
    // invitelist: true,
};

export default ALL_URL;
